module.exports = __webpack_public_path__ + "static/img/13.35883b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/13.png
// module id = 2jhr
// module chunks = 0